import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CustompageService } from '../../../../../services/api-store/custompage/custompage.service';
import { SpinnerService } from '../../../../../services/spinner/spinner.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { UtilsService } from '../../../../../services/utils-folder/utils.service';
import { GalleryRequestSearch } from '../../../../../models/api-dam/gallery/gallery-request.model';
import { GalleryService } from '../../../../../services/api-dam/gallery/gallery.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImmaginiCreateComponent } from '../../../dam/immagini/immagini-create/immagini-create.component';
import { LoadImageFromDamComponent } from '../../../../../components/ui/load-image-from-dam/load-image-from-dam.component';
import { ImageResponseGet } from '../../../../../models/api-dam/image/image-response.model';
import { ImageService } from '../../../../../services/api-dam/image/image.service';
import { NewsFilterRequestSearch } from '../../../../../models/api-store/news-filter/news-filter.request.model';
import { NewsFilterService } from '../../../../../services/api-store/news-filter/news-filter.service';
import { PromotionEventRequestSearch } from '../../../../../models/api-store/promotion-event/promotion-event.request.model';
import { PromotionEventService } from '../../../../../services/api-store/promotion-event/promotion-event.service';
import { ProductServiceService } from '../../../../../services/api-store/product-service/product-service.service';
import { ProductServiceRequestSearch } from '../../../../../models/api-store/product-service/product-service.request.model';
import { StoreService } from '../../../../../services/api-store/store/store.service';
import { ShoppingMallService } from '../../../../../services/api-store/shopping-mall/shopping-mall.service';
import { StoreRequestSearch } from '../../../../../models/api-store/store/store.request.model';
import { CustompageRequest, CustompageTemplate, CustompageImageType } from '../../../../../models/api-store/custompage/custompage.request.model';
import { environment } from '../../../../../../environments/environment';
import { DIALOG_LARGE_CONFIG } from '../../../../../utils/config/modal-settings';
import { LOADINGIMAGE } from '../../../../../utils/config/image-settings';
import { FALSE, TRUE } from '../../../../../utils/config/const';

@Component({
  selector: 'app-custompage-edit',
  templateUrl: './custompage-edit.component.html',
  styleUrls: ['./custompage-edit.component.css']
})
export class CustompageEditComponent implements OnInit, OnDestroy {

  id: number;
  formBuilder: FormGroup;
  fe_url: string = environment.frontendEnv.url;
  pageUrl: string = "";
  isVisibleLinkPageUrl: boolean = false;
  goBackUrl: string = "/custompage/custompage";
  request: any = {};
  isBtnVisibile: boolean = false;
  template: string = '';
  imageChoice: ImageResponseGet = new ImageResponseGet();
  visibleImageChoice: boolean = false;
  promoList: any[];
  productsList: any[];
  dealerCategoryList: any[];
  shoppingCentersList: any[];
  activitiesList: any[];
  originalPubValue: boolean;
  newsFilters: any = [];
  storeList: any = [];
  galleryIdsList: any;
  listOfProducts: any = [];
  listOfPromo: any = [];
  listOfDealer: any = [];
  listOfActivities: any = [];
  listOfMalls: any = [];
  initialGalleryValue = new FormControl('');
  isButtonSaveDisabled: boolean;
  ckeConfig: any;
  breadcrumbValue: string;
  mainContentValue: string;
  newsInsightsAbstractValue: string;
  legalNoteValue: string;
  @ViewChild("ckeditor") ckeditor: any;


  // Gallery Ids
  @ViewChild('galleryIds') galleryIds;
  galleryIdsKeyword = 'name';
  galleryIdsSuggestion: any = [];
  galleryIdsSelected: any = [];
  errorMsg: string;
  isGalleryIdsKeywordLoadingResult: boolean;

  //News Ids
  @ViewChild('newsIds') newsIds;
  newsIdsKeyword = 'name';
  newsIdsSuggestion: any = [];
  newsSelected: any = [];
  errorNewsMsg: string;
  isNewsIdsKeywordLoadingResult: boolean;

  // Store Ids
  @ViewChild('storeIds') storeIds;
  storeIdsKeyword = 'titleSeo';
  storeIdsSuggestion: any = [];
  storeSelected: any = [];
  errorStoreMsg: string;
  isStoreIdsKeywordLoadingResult: boolean;

  //System View
  systemView: any = {
    createdAt: "",
    createdBy: "",
    modifiedAt: "",
    modifiedBy: ""
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private custompageService: CustompageService,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private utilsService: UtilsService,
    private galleryService: GalleryService,
    private modalService: NgbModal,
    private imageService: ImageService,
    private newsFilterService: NewsFilterService,
    private promotionEventService: PromotionEventService,
    private productServiceService: ProductServiceService,
    private storeService: StoreService,
    private shoppingMallService: ShoppingMallService,
    public activeModal: NgbActiveModal
  ) {
    this.id = this.route.snapshot.params['id'];
    this.initForm();
    this.ckeConfig = this.utilsService.configCkeditor;
    this.imageChoice = new ImageResponseGet();
    this.visibleImageChoice = false;
  }

  ngOnInit(): void {
    this.loadDataByID(this.id);
    this.getPromo();
    this.getProducts();
    this.loadDealerCategoryList();
    this.loadActivitiesList();
    this.getShoppingCenters();
  }

  ngOnDestroy(): void {
    console.log(window["CKEDITOR"]);
  }

  get form() { return this.formBuilder; }
  get formControls() { return this.formBuilder.controls; }

  loadDataByID(idObj) {
    this.spinner.show();
    this.custompageService.getEntity(idObj).subscribe(
      (response) => {
        if (response) {
          if (response.published == TRUE) {
            this.isVisibleLinkPageUrl = true;
            this.pageUrl = this.fe_url + "it/" + response.seoId;
          }
          this.setFormValue(response);
          this.setSystemView(response);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni del\'appuntamento ', 'Caricamento appuntamento', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

  initForm() {
    this.breadcrumbValue = '';
    this.mainContentValue = '';
    this.newsInsightsAbstractValue = '';
    this.legalNoteValue = '';
    this.formBuilder = this.fb.group({
      title: ["", [Validators.required]],
      seoId: [""],
      previewImage: [""],
      breadcrumb: [""],
      seo: [""],
      seoTitle: [""],
      template: [""],
      published: [""],
      removeFooter: [""],
      enableListStoreOnMap: [""],
      menuLabel: [""],
      seoDescription: [""],
      seoNoindex: [""],
      mainContent: [""],
      imageType: ["SINGLE_IMAGE"],
      enableByCategoryNewsAndInsights: [""],
      newsInsightsTitle: [""],
      newsInsightsAbstract: [""],
      legalNote: [""],
    });
    this.isButtonSaveDisabled = false;
  }

  setSystemView(response) {
    this.systemView = {
      createdAt: response.createdAt,
      createdBy: response.createdBy,
      modifiedAt: response.modifiedAt,
      modifiedBy: response.modifiedBy
    };
  }

  setFormValue(response) {
    let listOfFields = Object.keys(this.formBuilder.controls);
    listOfFields.forEach(field => {
      if (response[field] != null) {
        this.formBuilder.controls[field].setValue(response[field]);
        switch (field) {
          case 'breadcrumb': this.breadcrumbValue = this.formBuilder.controls['breadcrumb'].value; break;
          case 'mainContent': this.mainContentValue = this.formBuilder.controls['mainContent'].value; break;
          case 'newsInsightsAbstract': this.newsInsightsAbstractValue = this.formBuilder.controls['newsInsightsAbstract'].value; break;
          case 'legalNote': this.legalNoteValue = this.formBuilder.controls['legalNote'].value; break;
        }
      }
    });

    this.template = response.template;
    this.originalPubValue = response.published;
    if (response.newsFilters.length > 0) {
      this.getNewsChips(response.newsFilters);
    }
    if (response.store.length > 0) {
      this.getStoreChips(response.store);
    }
    if (response.galleryId) {
      this.selectGalleryIdsEvent(response.galleryId)
      this.initialGalleryValue = new FormControl(response.galleryId.name);
    }
    if (response.singleImageId) {
      this.getImage(response.singleImageId);
    }
    if (response.productServices.length > 0) {
      this.listOfProducts = response.productServices;
    }
    if (response.promotionEvents.length > 0) {
      this.listOfPromo = response.promotionEvents;
    }
    if (response.dealerMap.length > 0) {
      this.listOfDealer = response.dealerMap;
    }
    if (response.activityMap.length > 0) {
      this.listOfActivities = response.activityMap;
    }
    if (response.shoppingMalls.length > 0) {
      this.listOfMalls = response.shoppingMalls;
    }
  }

  /**
 * Azione click su button Annulla
 */
  clickButtonCancel() {
    //Torna indietro alla tabella
    this.router.navigate([this.goBackUrl]);
  }

  //Autocomplete - newsIds <- News e approfondimenti

  getNewsIdsRequest(event) {
    let request = new NewsFilterRequestSearch();
    request.name = event;
    request.pageNumber = 0;
    request.pageSize = 20;
    return request;
  }
  fill_newsIdsSuggestion(response) {
    for (let obj of response.data) {
      let trovato = false;
      for (let j = 0; j < this.newsSelected.length && !trovato; j++) {
        if (obj.id == this.newsSelected[j].id) {
          trovato = true;
        }
      }
      if (!trovato) {
        this.newsIdsSuggestion.push(obj);
      }
    }
  }
  getNewsIdsList(event) {
    this.change();
    this.isNewsIdsKeywordLoadingResult = true;
    let request = this.getNewsIdsRequest(event);
    this.newsFilterService.search(request).subscribe(response => {
      this.newsIdsSuggestion = [];
      if (response != null && typeof response != typeof undefined) {
        //aggiungo elementi nella suggestion
        this.fill_newsIdsSuggestion(response);
      }
      this.isNewsIdsKeywordLoadingResult = false;
    });
  }
  searchNewsIdsCleared() {
    this.change();
    this.newsIdsSuggestion = [];
  }
  selectNewsIdsEvent(item) {
    this.newsSelected.push(item);
    this.newsFilters.push(item.id);
    this.newsIds.clear();
  }
  onChangeNewsSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }
  onNewsIdsFocused(e) {
    console.log(e);
    this.getNewsIdsList("");
    // do something when input is focused
  }
  //Chip list - newsIds <- Promo e News
  labelKeysNewsIds = ["name"];
  onChangeItemListNewsIdsSelected(newsChips) {
    this.newsFilters = [];
    newsChips.forEach(item => {
      if (item) {
        this.newsFilters.push(item.id);
      }
    });
  }

  getNewsChips(filtersData) {
    filtersData.forEach(element => {
      if (element) {
        this.selectNewsIdsEvent(element);
      }
    });
  }

  //Autocomplete - galleryIds <- Galleria immagini
  getGalleryIdsRequest(event) {
    let request = new GalleryRequestSearch();
    request.name = event;
    request.published = true;
    request.pageNumber = 0;
    request.pageSize = 20;
    return request;
  }
  fill_galleryIdsSuggestion(response) {
    for (let obj of response.data) {
      let trovato = false;
      for (let j = 0; j < this.galleryIdsSelected.length && !trovato; j++) {
        if (obj.id == this.galleryIdsSelected[j].id) {
          trovato = true;
        }
      }
      if (!trovato) {
        this.galleryIdsSuggestion.push(obj);
      }
    }
  }
  getGalleryIdsList(event) {
    this.change();
    this.isGalleryIdsKeywordLoadingResult = true;
    let request = this.getGalleryIdsRequest(event);
    this.galleryService.search(request).subscribe(response => {

      this.galleryIdsSuggestion = [];
      if (response != null && typeof response != typeof undefined) {
        //aggiungo elementi nella suggestion
        this.fill_galleryIdsSuggestion(response);
      }
      this.isGalleryIdsKeywordLoadingResult = false;
    });
  }
  searchGalleryIdsCleared() {
    this.change();
    this.galleryIdsSuggestion = [];
    this.galleryIdsSelected = [];
    this.galleryIdsList = undefined;
  }
  selectGalleryIdsEvent(item) {
    this.galleryIdsSelected.push(item);
    this.galleryIdsList = item.id;
  }
  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }
  onGalleryIdsFocused(e) {
    console.log(e);
    this.getGalleryIdsList("");
    // do something when input is focused
  }
  //Chip list - galleryIds <- Galleria immagini
  labelKeysGalleryIds = ["name"];
  onChangeItemListGalleryIdsSelected($event) {
    console.log($event);
  }

  //Autocomplete - storeIds <- Store
  getStoreIdsRequest(event) {
    let request = new StoreRequestSearch();
    request.q = event;
    request.pageNumber = 0;
    request.pageSize = 20;
    return request;
  }
  fill_storeIdsSuggestion(response) {
    for (let obj of response.data) {
      let trovato = false;
      for (let j = 0; j < this.storeSelected.length && !trovato; j++) {
        if (obj.id == this.storeSelected[j].id) {
          trovato = true;
        }
      }
      if (!trovato) {
        this.storeIdsSuggestion.push(obj);
      }
    }
  }
  getStoreIdsList(event) {
    this.change();
    this.isStoreIdsKeywordLoadingResult = true;
    let request = this.getStoreIdsRequest(event);
    this.storeService.search(request).subscribe(response => {

      this.storeIdsSuggestion = [];
      if (response != null && typeof response != typeof undefined) {
        //aggiungo elementi nella suggestion
        this.fill_storeIdsSuggestion(response);
      }
      this.isStoreIdsKeywordLoadingResult = false;
    });
  }
  searchStoreIdsCleared() {
    this.change();
    this.storeIdsSuggestion = [];
  }
  selectStoreIdsEvent(item) {
    this.storeSelected.push(item);
    this.storeList.push(item.id);
    if (this.storeIds) {
      this.storeIds.clear();
    }
  }
  onChangeStoreSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }
  onStoreIdsFocused(e) {
    console.log(e);
    this.getStoreIdsList("");
    // do something when input is focused
  }
  //Chip list - Custom Page <- Store
  labelKeysStoreIds = ["titleSeo"];
  onChangeItemListStoreIdsSelected(storeChips) {
    this.storeList = [];
    storeChips.forEach(item => {
      if (item) {
        this.storeList.push(item.id);
      }
    });
  }

  getStoreChips(storeData) {
    storeData.forEach(element => {
      if (element) {
        this.selectStoreIdsEvent(element);
      }
    });
  }



  // Recupera immagine dalla response
  getImage(id) {
    this.formBuilder.controls['previewImage'].setValue(id);
    this.loadImage(this.formBuilder.controls['previewImage'].value);
  }

  /**
* Azione click su button Carica da PC
*/
  openLoadImageFromPC() {
    //Apre modale di create
    const modalRef = this.modalService.open(ImmaginiCreateComponent, DIALOG_LARGE_CONFIG);
    modalRef.result.then(result => {
      if (result && result != "CLOSE") {
        if (this.formBuilder.controls['previewImage'].value != parseInt(result.id)) {
          this.formBuilder.controls['previewImage'].setValue(result.id);
          this.loadImage(this.formBuilder.controls['previewImage'].value);
        }
      }
    });
  }



  /**
   * Azione click su button carica da D.A.M
   */
  openLoadImageFromDAM() {
    //Apertura modale di modifica 
    let value = this.formBuilder.controls['previewImage'].value;
    const modalRef = this.modalService.open(LoadImageFromDamComponent, DIALOG_LARGE_CONFIG);
    if (value == "" || value == null) {
      value = [];
    } else {
      value = [value];
    }
    modalRef.componentInstance.multiple = false;
    modalRef.componentInstance.idImages = value;
    modalRef.result.then((result: any) => {
      if (result) {
        if (result.images.length > 0) {
          if (this.formBuilder.controls['previewImage'].value != parseInt(result.images[0].id)) {
            this.formBuilder.controls['previewImage'].setValue(result.images[0].id);
            this.loadImage(this.formBuilder.controls['previewImage'].value);
          }
        } else {
          this.imageChoice = this.imageChoice = new ImageResponseGet();
          this.visibleImageChoice = false;
          this.formBuilder.controls['previewImage'].setValue(null);
        }
      }
    });
  }

  deleteImage() {
    this.imageChoice = new ImageResponseGet();
    this.visibleImageChoice = false;
    this.formBuilder.controls['previewImage'].setValue(null);
  }


  loadImage(id) {
    this.visibleImageChoice = true;
    this.imageService.getEntity(id).subscribe(
      (response) => {
        this.insertImage(response);
      },
      (error) => {
        this.toastr.error('Si è verificato un errore durante il caricamento dell\'immagine', 'Caricamento immagine fallita', {
          timeOut: 5000
        });
      }
    );
  }

  insertImage(imageObj) {
    this.imageChoice = imageObj;
    let idImage = imageObj.id;
    if (imageObj.published === FALSE) {
      this.imageChoice.url = LOADINGIMAGE;
    }
    if (imageObj.published === FALSE) {
      this.downloadImage(idImage);
    }
  }
  /**
   * Carica immagine non pubblica
   * @param idImage 
   */
  downloadImage(idImage) {
    this.imageService.download(idImage).subscribe(
      (response) => {
        this.imageChoice.url = this.utilsService.getSecurityTrustURL(response);
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.imageChoice.url = "/assets/images/no-image-icon.png";
      }
    );
  }

  getPromo() {
    let documentRequestSearch = this.getPromoFilter();
    this.promotionEventService.search(documentRequestSearch).subscribe(
      (response) => {
        if (response != null && typeof response != typeof undefined) {
          if (response.data.length > 0) {
            this.promoList = response.data;
            this.getPromotionFromList();
          }
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.spinner.hide();
      }
    );

  }

  getPromoFilter() {
    let promotionEventRequestSearch = new PromotionEventRequestSearch();
    promotionEventRequestSearch.pageNumber = 0;
    promotionEventRequestSearch.pageSize = 50;
    promotionEventRequestSearch.published = true;
    return promotionEventRequestSearch;
  }

  getProducts() {
    let documentRequestSearch = this.getProductsFilter();
    this.productServiceService.search(documentRequestSearch).subscribe(
      (response) => {
        if (response != null && typeof response != typeof undefined) {
          if (response.data.length > 0) {
            this.productsList = response.data;
            this.getProductsFromList();
          }
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.spinner.hide();
      }
    );

  }

  getProductsFilter() {
    let promotionEventRequestSearch = new ProductServiceRequestSearch();
    promotionEventRequestSearch.pageNumber = 0;
    promotionEventRequestSearch.pageSize = 50;
    promotionEventRequestSearch.published = true;
    return promotionEventRequestSearch;
  }

  getProductsToList() {
    this.listOfProducts = [];
    let listOfCheckboxes = document.getElementsByName('productscheckbox') as any;
    listOfCheckboxes.forEach((item, i,) => {
      if (item.checked == TRUE) {
        this.listOfProducts.push(item.value);
      }
    })
    return this.listOfProducts;
  }

  getProductsFromList() {
    setTimeout(() => {
      let listOfCheckboxes = document.getElementsByName('productscheckbox') as any;
      this.listOfProducts.forEach(element => {
        if (element) {
          listOfCheckboxes.forEach((item, i,) => {
            if (item.value == element.id) {
              item.checked = true;
            }
          });
        }
      });
    }, 1000);
  }

  getPromotionToList() {
    this.listOfPromo = [];
    let listOfCheckboxes = document.getElementsByName('promocheckbox') as any;
    listOfCheckboxes.forEach((item, i,) => {
      if (item.checked == TRUE) {
        this.listOfPromo.push(item.value);
      }
    })
    return this.listOfPromo;
  }

  getPromotionFromList() {
    setTimeout(() => {
      let listOfCheckboxes = document.getElementsByName('promocheckbox') as any;
      this.listOfPromo.forEach(element => {
        if (element) {
          listOfCheckboxes.forEach((item, i,) => {
            if (item.value == element.id) {
              item.checked = true;
            }
          });
        }
      });
    }, 1000);
  }

  getDealerToList() {
    this.listOfDealer = [];
    let listOfCheckboxes = document.getElementsByName('dealercheckbox') as any;
    listOfCheckboxes.forEach((item, i,) => {
      if (item.checked == TRUE) {
        this.listOfDealer.push(item.value);
      }
    })
    return this.listOfDealer;
  }

  getDealerFromList() {
    setTimeout(() => {
      let listOfCheckboxes = document.getElementsByName('dealercheckbox') as any;
      this.listOfDealer.forEach(element => {
        if (element) {
          listOfCheckboxes.forEach((item, i,) => {
            if (item.value == element.id) {
              item.checked = true;
            }
          });
        }
      });
    }, 1000);
  }

  getActivitiesToList() {
    this.listOfActivities = [];
    let listOfCheckboxes = document.getElementsByName('activitiescheckbox') as any;
    listOfCheckboxes.forEach((item, i,) => {
      if (item.checked == TRUE) {
        this.listOfActivities.push(item.value);
      }
    })
    return this.listOfActivities;
  }

  getActivitiesFromList() {
    setTimeout(() => {
      let listOfCheckboxes = document.getElementsByName('activitiescheckbox') as any;
      this.listOfActivities.forEach(element => {
        if (element) {
          listOfCheckboxes.forEach((item, i,) => {
            if (item.value == element.id) {
              item.checked = true;
            }
          });
        }
      });
    }, 1000);
  }

  getShoppingCenterToList() {
    this.listOfMalls = [];
    let listOfCheckboxes = document.getElementsByName('mallcheckbox') as any;
    listOfCheckboxes.forEach((item, i,) => {
      if (item.checked == TRUE) {
        this.listOfMalls.push(item.value);
      }
    })
    return this.listOfMalls;
  }

  getShoppingCenterFromList() {
    setTimeout(() => {
      let listOfCheckboxes = document.getElementsByName('mallcheckbox') as any;
      this.listOfMalls.forEach(element => {
        if (element) {
          listOfCheckboxes.forEach((item, i,) => {
            if (item.value == element.id) {
              item.checked = true;
            }
          });
        }
      });
    }, 1000);
  }

  loadDealerCategoryList() {
    this.custompageService.findAllDealer().subscribe(
      (response) => {
        if (response != null && typeof response != typeof undefined) {
          if (response.data.length > 0) {
            this.dealerCategoryList = response.data;
            this.getDealerFromList();
          }
        }
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      }
    );
  }

  loadActivitiesList() {
    this.custompageService.findAllActivitesList().subscribe(
      (response) => {
        if (response != null && typeof response != typeof undefined) {
          if (response.data.length > 0) {
            this.activitiesList = response.data;
            this.getActivitiesFromList();
          }
        }
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      }
    );
  }

  getShoppingCenters() {
    this.shoppingMallService.findAll().subscribe(
      (response) => {
        if (response != null && typeof response != typeof undefined) {
          if (response.data.length > 0) {
            this.shoppingCentersList = response.data;
            this.getShoppingCenterFromList();
          }
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.spinner.hide();
      }
    );
  }

  getFormValue() {
    let request = new CustompageRequest();
    request.title = this.formBuilder.controls['title'].value;
    request.seoId = this.formBuilder.controls['seoId'].value;
    request.seoTitle = this.formBuilder.controls['seoTitle'].value;
    request.published = this.formBuilder.controls['published'].value;
    request.removeFooter = this.formBuilder.controls['removeFooter'].value;
    request.seoDescription = this.formBuilder.controls['seoDescription'].value;
    request.menuLabel = this.formBuilder.controls['menuLabel'].value;
    request.seoNoindex = this.formBuilder.controls['seoNoindex'].value;
    request.mainContent = this.mainContentValue;
    request.enableByCategoryNewsAndInsights = this.formBuilder.controls['enableByCategoryNewsAndInsights'].value;
    request.newsInsightsTitle = this.formBuilder.controls['newsInsightsTitle'].value;
    request.newsInsightsAbstract = this.newsInsightsAbstractValue;
    request.breadcrumb = this.breadcrumbValue;
    request.newsFilters = this.newsFilters;
    if (this.formBuilder.controls['imageType'].value == 'SINGLE_IMAGE') {
      request.imageType = CustompageImageType.SINGLE_IMAGE;
    }
    if (this.formBuilder.controls['imageType'].value == 'GALLERY') {
      request.imageType = CustompageImageType.GALLERY;
    }
    if (typeof this.imageChoice.id != typeof undefined) {
      request.singleImageId = this.imageChoice.id;
    }
    if (typeof this.galleryIdsList != typeof undefined) {
      request.galleryId = this.galleryIdsList;
    }

    if (this.template == 'MAP') {
      request.template = CustompageTemplate.MAP;
      request.enableListStoreOnMap = this.formBuilder.controls['enableListStoreOnMap'].value;
      request.productServices = this.getProductsToList();
      request.promotionEvents = this.getPromotionToList();
      request.dealerMap = this.getDealerToList();
      request.activityMap = this.getActivitiesToList();
      request.shoppingMalls = this.getShoppingCenterToList();
      request.store = this.storeList;
      request.legalNote = this.legalNoteValue;
    }

    if (this.template == 'CLEAN') {
      request.template = CustompageTemplate.CLEAN;
    }
    return request;
  }

  save() {
    this.request = this.getFormValue();
    this.spinner.show();
    this.custompageService.update(this.id, this.request).subscribe(
      (response) => {
        if (response) {
          //Salvata modifica
          this.toastr.success('Pagina custom modificata con successo', 'Modifica Pagina Custom', {
            timeOut: 5000
          });
          if (this.originalPubValue != this.request.published) {
            this.publish();
          } else {
            this.clickButtonCancel();
          }
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante la modifica della Pagina Custom', 'Modifica Pagina Custom', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );

  }

  /**
   * Azione click su button salva modifiche
   */
  clickButtonSave() {
    if (this.formBuilder.status === 'VALID' && this.formBuilder.touched == TRUE) {
      this.isButtonSaveDisabled = true;
      this.save();
    }
  }

  getPubValue() {
    let request = this.formBuilder.controls['published'].value;
    return request;
  }

  publish() {
    this.request = this.getPubValue();
    this.custompageService.publish(this.id, this.request).subscribe(
      (response) => {
        if (this.request == TRUE) {
          //Salvata modifica
          this.toastr.success('Pagina Custom pubblicata con successo', 'Pubblica Pagina custom', {
            timeOut: 5000
          });
        } else {
          //Salvata modifica
          this.toastr.success('Pagina Custom depubblicata con successo', 'Depubblica Pagina custom', {
            timeOut: 5000
          });
        }
        this.spinner.hide();
        this.clickButtonCancel();
      },
      (error: HttpErrorResponse) => {
        if (this.request == TRUE) {
          this.toastr.error('Si è verificato un errore durante la pubblicazione della Pagina custom ', 'Pubblica Pagina custom fallita', {
            timeOut: 5000
          });
        } else {
          this.toastr.error('Si è verificato un errore durante la depubblicazione della Pagina custom ', 'Depubblica Pagina custom fallita', {
            timeOut: 5000
          });
        }
        console.log(error);
        this.spinner.hide();
      }
    );
  }

  onTemplateChange() {
    if (this.template == 'MAP') {
      this.getProductsFromList();
      this.getPromotionFromList();
      this.getDealerFromList();
      this.getActivitiesFromList();
      this.getShoppingCenterFromList();
    }
  }

  change() {
    this.form.markAsTouched();
  }

}
